import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Generate from './pages/Generate';
import Gallery from './pages/Gallery';
import About from './pages/About';
import Help from './pages/Help';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-900 text-white">
        <Navbar />
        <main className="w-full px-2 py-4 sm:px-4 sm:py-8">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/generate" element={<Generate />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/about" element={<About />} />
            <Route path="/help" element={<Help />} />
          </Routes>
        </main>
        <div className="mt-12 bg-gray-900 p-6 rounded-lg text-center">
          <h3 className="text-xl font-bold mb-2">Why use AI Image Generator?</h3>
          <p className="text-gray-300 mb-2">
            Our tool empowers you to turn your ideas into beautiful images in seconds. Whether you need artwork for your projects, social media, or just for fun, AI Image Generator makes creativity accessible to everyone.
          </p>
          <p className="text-gray-400 text-sm">
            No design skills required. Just describe your vision and let AI do the rest!
          </p>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
